// commonReducer.js
import moment from 'moment';
import { GET_NOTIFICATIONS, GET_NOTIFICATIONS_FAILURE, GET_NOTIFICATIONS_SUCCESS, GET_NOTIFICATION_USERS, GET_NOTIFICATION_USERS_SUCCESS, GET_NOTIFICATION_USERS_FAILURE, GET_ADMIN_NOTIFICATIONS, GET_ADMIN_NOTIFICATIONS_SUCCESS, GET_ADMIN_NOTIFICATIONS_FAILURE, GET_ADMIN_NOTIFICATIONS_BADGE_SUCCESS, GET_SUBSCRIPTION_PLANS, GET_SUBSCRIPTION_PLANS_SUCCESS, GET_SUBSCRIPTION_PLANS_FAILURE, EDIT_SUBSCRIPTION_PLAN_SUCCESS, DELETE_SUBSCRIPTION_PLAN_SUCCESS, MARK_ADMIN_NOTIFICATION_ITEM_AS_READ_SUCCESS, GET_DASHBOARD_SUMMARY, GET_DASHBOARD_SUMMARY_SUCCESS, GET_DASHBOARD_SUMMARY_FAILURE, GET_DASHBOARD_MANAGER_SUMMARY, GET_DASHBOARD_MANAGER_SUMMARY_SUCCESS, GET_DASHBOARD_MANAGER_SUMMARY_FAILURE, GET_DASHBOARD_PIPELINE, GET_DASHBOARD_PIPELINE_SUCCESS, GET_DASHBOARD_PIPELINE_FAILURE, GET_ACCOUNT_MANAGERS, GET_ACCOUNT_MANAGERS_SUCCESS, GET_ACCOUNT_MANAGERS_FAILURE, GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY, GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY_SUCCESS, GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY_FAILURE, GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY, GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY_SUCCESS, GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY_FAILURE, GET_DASHBOARD_APP_SUMMARY, GET_DASHBOARD_APP_SUMMARY_SUCCESS, GET_DASHBOARD_APP_SUMMARY_FAILURE, SET_DASHBOARD_TIME_PERIOD, SET_ACTIVE_MANAGER, GET_DASHBOARD_MOM_TRENDS, GET_DASHBOARD_MOM_TRENDS_SUCCESS, GET_DASHBOARD_MOM_TRENDS_FAILURE, GET_COMMERCIAL_TERMS_SUCCESS, EDIT_COMMERCIAL_TERMS_SUCCESS, DELETE_COMMERCIAL_TERMS_SUCCESS, GET_DASHBOARD_MONTHLY_TRENDS, GET_DASHBOARD_MONTHLY_TRENDS_SUCCESS, GET_DASHBOARD_MONTHLY_TRENDS_FAILURE, GET_DASHBOARD_PENDING_DETAILS_CANDIDATES, GET_DASHBOARD_PENDING_DETAILS_CANDIDATES_SUCCESS, GET_DASHBOARD_PENDING_DETAILS_CANDIDATES_FAILURE } from '../actions/commonActions';

const today = moment().startOf("day");

const initialState = {
  notifications: [],
  notificationUsers: [],
  adminNotifications: [],
  adminNotificationsBadge: 0,
  subscriptionPlans: [],
  commercialTerms: [],
  dashboardSummaryData: null,
  dashboardAppSummaryData: null,
  dashboardManagerSummaryData: null,
  dashboardPipelineData: [],
  accountManagers: [],
  dashboardJobApplicationMonthlySummaryData: [],
  dashboardPipelineMonthlySummaryData: [],
  dashboardMoMTrendsData: [],
  dashboardMonthlyTrendsData: [],
  dashboardPendingDetailsCandidates: [],
  dashboardTimePeriod: {
    'rangeType': 'This Month',
    'fromDate': today.clone().startOf("month").format("YYYY-MM-DD"),
    'toDate': today.clone().endOf("month").format("YYYY-MM-DD")
  },
  activeManager: null
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS:
      return {
        ...state,
      };

    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.payload,
      };

    case GET_NOTIFICATIONS_FAILURE:
      return {
        ...state,
      };

    case GET_NOTIFICATION_USERS:
      return {
        ...state,
      };

    case GET_NOTIFICATION_USERS_SUCCESS:
      return {
        ...state,
        notificationUsers: action.payload,
      };

    case GET_NOTIFICATION_USERS_FAILURE:
      return {
        ...state,
      };

    case GET_ADMIN_NOTIFICATIONS:
      return {
        ...state,
      };

    case GET_ADMIN_NOTIFICATIONS_SUCCESS:
      if (action.payload?.metadata?.pageNumber > 0) {
        return {
          ...state,
          adminNotifications: {
            ...state.adminNotifications,
            data: [...state.adminNotifications?.data, ...action.payload?.data]
          }
        };
      } else {
        return {
          ...state,
          adminNotifications: action.payload,
        };
      }

    case GET_ADMIN_NOTIFICATIONS_FAILURE:
      return {
        ...state,
      };

    case GET_ADMIN_NOTIFICATIONS_BADGE_SUCCESS:
      return {
        ...state,
        adminNotificationsBadge: action.payload,
      };

    case MARK_ADMIN_NOTIFICATION_ITEM_AS_READ_SUCCESS:
      return {
        ...state,
        adminNotificationsBadge: {
          ...state.adminNotificationsBadge,
          data: state.adminNotificationsBadge?.data > 0
            ? state.adminNotificationsBadge?.data - 1
            : state.adminNotificationsBadge?.data
        }
      };

    case GET_SUBSCRIPTION_PLANS:
      return {
        ...state,
      };

    case GET_SUBSCRIPTION_PLANS_SUCCESS:
      return {
        ...state,
        subscriptionPlans: action.payload,
      };

    case GET_SUBSCRIPTION_PLANS_FAILURE:
      return {
        ...state,
      };

    case EDIT_SUBSCRIPTION_PLAN_SUCCESS:
      return {
        ...state,
        subscriptionPlans: {
          ...state.subscriptionPlans,
          data: state.subscriptionPlans?.data.map(existingSubscriptionPlan =>
            (existingSubscriptionPlan.id === action.payload?.id)
              ? { ...existingSubscriptionPlan, ...action.payload }
              : existingSubscriptionPlan)
        }
      };

    case DELETE_SUBSCRIPTION_PLAN_SUCCESS:
      return {
        ...state,
        subscriptionPlans: {
          ...state.subscriptionPlans,
          data: state.subscriptionPlans?.data.filter(existingSubscriptionPlan => existingSubscriptionPlan.id !== action.payload)
        },
      };

    case GET_COMMERCIAL_TERMS_SUCCESS:
      return {
        ...state,
        commercialTerms: action.payload,
      };


    case EDIT_COMMERCIAL_TERMS_SUCCESS:
      return {
        ...state,
        commercialTerms: {
          ...state.commercialTerms,
          data: state.commercialTerms?.data.map(existingCommercialTerms =>
            (existingCommercialTerms.id === action.payload?.id)
              ? { ...existingCommercialTerms, ...action.payload }
              : existingCommercialTerms)
        }
      };

    case DELETE_COMMERCIAL_TERMS_SUCCESS:
      return {
        ...state,
        commercialTerms: {
          ...state.commercialTerms,
          data: state.commercialTerms?.data.filter(existingCommercialTerms => existingCommercialTerms.id !== action.payload)
        },
      };

    case GET_DASHBOARD_SUMMARY:
      return {
        ...state,
      };

    case GET_DASHBOARD_SUMMARY_SUCCESS:
      return {
        ...state,
        dashboardSummaryData: action.payload,
      };

    case GET_DASHBOARD_SUMMARY_FAILURE:
      return {
        ...state,
      };

    case GET_DASHBOARD_APP_SUMMARY:
      return {
        ...state,
      };

    case GET_DASHBOARD_APP_SUMMARY_SUCCESS:
      return {
        ...state,
        dashboardAppSummaryData: action.payload,
      };

    case GET_DASHBOARD_APP_SUMMARY_FAILURE:
      return {
        ...state,
      };

    case GET_DASHBOARD_MANAGER_SUMMARY:
      return {
        ...state,
      };

    case GET_DASHBOARD_MANAGER_SUMMARY_SUCCESS:
      return {
        ...state,
        dashboardManagerSummaryData: action.payload,
      };

    case GET_DASHBOARD_MANAGER_SUMMARY_FAILURE:
      return {
        ...state,
      };

    case GET_DASHBOARD_PIPELINE:
      return {
        ...state,
      };

    case GET_DASHBOARD_PIPELINE_SUCCESS:
      return {
        ...state,
        dashboardPipelineData: action.payload,
      };

    case GET_DASHBOARD_PIPELINE_FAILURE:
      return {
        ...state,
      };

    case GET_DASHBOARD_PENDING_DETAILS_CANDIDATES:
      return {
        ...state,
      };

    case GET_DASHBOARD_PENDING_DETAILS_CANDIDATES_SUCCESS:
      return {
        ...state,
        dashboardPendingDetailsCandidates: action.payload,
      };

    case GET_DASHBOARD_PENDING_DETAILS_CANDIDATES_FAILURE:
      return {
        ...state,
      };

    case GET_ACCOUNT_MANAGERS:
      return {
        ...state,
      };

    case GET_ACCOUNT_MANAGERS_SUCCESS:
      return {
        ...state,
        accountManagers: action.payload,
      };

    case GET_ACCOUNT_MANAGERS_FAILURE:
      return {
        ...state,
      };

    case GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY:
      return {
        ...state,
      };

    case GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY_SUCCESS:
      return {
        ...state,
        dashboardJobApplicationMonthlySummaryData: action.payload,
      };

    case GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY_FAILURE:
      return {
        ...state,
      };

    case GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY:
      return {
        ...state,
      };

    case GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY_SUCCESS:
      return {
        ...state,
        dashboardPipelineMonthlySummaryData: action.payload,
      };

    case GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY_FAILURE:
      return {
        ...state,
      };

    case GET_DASHBOARD_MOM_TRENDS:
      return {
        ...state,
      };

    case GET_DASHBOARD_MOM_TRENDS_SUCCESS:
      return {
        ...state,
        dashboardMoMTrendsData: action.payload,
      };

    case GET_DASHBOARD_MOM_TRENDS_FAILURE:
      return {
        ...state,
      };

    case GET_DASHBOARD_MONTHLY_TRENDS:
      return {
        ...state,
      };

    case GET_DASHBOARD_MONTHLY_TRENDS_SUCCESS:
      return {
        ...state,
        dashboardMonthlyTrendsData: action.payload,
      };

    case GET_DASHBOARD_MONTHLY_TRENDS_FAILURE:
      return {
        ...state,
      };

    case SET_DASHBOARD_TIME_PERIOD:
      return {
        ...state,
        dashboardTimePeriod: action.payload,
      };

    case SET_ACTIVE_MANAGER:
      return {
        ...state,
        activeManager: action.payload,
      };

    default:
      return state;
  }
};

export default commonReducer;
